import { useMutation } from '@tanstack/react-query';

export interface UploadedFile {
  path: string;
  originalname: string;
  mimetype: string;
  size: number;
}

/** Upload genérico (`/uploads/files`) — aceita qualquer tipo de arquivo. */
export function useUploadFile() {
  return useMutation({
    mutationFn: async (file: File): Promise<UploadedFile> => {
      const formData = new FormData();
      formData.append('file', file);

      const res = await fetch('/api/v1/uploads/files', {
        method: 'POST',
        body: formData,
      });
      if (!res.ok) throw new Error('Falha ao enviar o arquivo.');

      const data = await res.json();
      return data.file;
    },
  });
}
